import { takeEvery, put, all } from 'redux-saga/effects';

import { toastr } from 'react-redux-toastr';

import * as types from '../actions/vacancies/vacancy-access/types';
import * as actions from '../actions/vacancies/vacancy-access';

import apiFetcher from '../tools/api-fetcher';
import handleError from '../tools/error-helper';

function* getVacancySchoolUsersSummaries({ schoolId, vacancyId }) {
  yield put(actions.setFormLoading(true));

  try {
    const { data } = yield apiFetcher
      .auth()
      .get(`/schools/${schoolId}/vacancies/${vacancyId}/access/summaries`);

    yield put(actions.setVacancySchoolUsersSummaries(data));
  } catch (exception) {
    handleError(exception, `Failed to load vacancy access summaries.`);
  }

  yield put(actions.setFormLoading(false));
}

function* setVacancySchoolUsersToDeny({ schoolId, vacancyId, putSchoolUsersToDenyAccessRequest }) {
  yield put(actions.setFormUpdating(true));

  try {
    yield apiFetcher
      .auth()
      .put(
        `/schools/${schoolId}/vacancies/${vacancyId}/access/deny`, 
        putSchoolUsersToDenyAccessRequest
      );

    yield put(actions.getVacancySchoolUsersSummaries(schoolId, vacancyId));

    toastr.success(
      `School users were successfully denied from accessing the vacancy.`
    );
  } catch (exception) {
    handleError(exception, `Failed to set school users with denied access to the vacancy.`);
  }

  yield put(actions.setFormUpdating(false));
}

export default function* vacancyAccessSaga() {
  yield all([
    takeEvery(
      types.VACANCY_ACCESS_GET_SCHOOL_USERS_SUMMARIES,
      getVacancySchoolUsersSummaries
    ),
    takeEvery(
      types.VACANCY_ACCESS_SET_SCHOOL_USERS_TO_DENY,
      setVacancySchoolUsersToDeny
    )
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/vacancy-access.js